<template>
    <v-container>
        <branch-office-not-set-blocker/>
        <v-layout align-start wrap>
            <v-flex xs12>
                <w-main-title
                    class="pb-0"
                    :title="clientsLabel"
                    :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>
        </v-layout>
        <v-layout wrap class="search-wrapper">
            <v-flex xs12 text-xs-right px-1>
                <v-text-field
                    hide-details
                    label="Buscar"
                    placeholder="Escribe nombre, apellido, rut, email o teléfono..."
                    prepend-inner-icon="search"
                    @click:clear="search=''"
                    v-model="search"
                    clearable
                    height="42"
                />
            </v-flex>
        </v-layout>
        <provider-client-list
            @loading="loading = $event"
            :search="search"
            hide-local-search
            :labels="labels"
        />
    </v-container>
</template>
<script>

import WMainTitle from '@/components/common/WMainTitle'
import ProviderClientList from "../../components/client/ProviderClientList";
import BranchOfficeNotSetBlocker from "../../components/providers/BranchOfficeNotSetBlocker";
import {getLabel} from '@/utils/Institution'

export default {
    components: {
        BranchOfficeNotSetBlocker,
        ProviderClientList,
        WMainTitle
    },
    data() {
        return {
            search: '',
            labels: [],
            loading: true
        }
    },
    methods: {
        onLabelsChange(val) {
            this.labels = val
        }
    },
    computed: {
        clientsLabel() {
            return getLabel('commons.client.plural')
        },
        breadcrumbs() {
            const vm = this
            return [
                {
                    text: vm.clientsLabel,
                    disabled: true,
                    to: ''
                },
            ]
        }
    }
}
</script>

<style scoped>
.search-wrapper {
    padding: 5px;
    position: sticky !important;
    top: 10px !important;
    border-radius: 8px;
    z-index: 1;
    background-color: #ececec
}
</style>